import React from 'react';
import PropTypes from 'prop-types';
import { Row, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const AccountActions = require('../../actions/AccountActions');
const ForgeError = require('../../util/error');
//import ErrorBox from '../common/ErrorBox';
import AvatarButton from '../DashboardNew/Menu/AvatarButton';
const AvatarSelect = require('../ShortCourse/play/AvatarSelect');

const propTypes = {
    user: PropTypes.object.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    buttonTitle: PropTypes.string,
    onSave: PropTypes.func,
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {
    className: '',
    disabled: false,
    buttonTitle: '',
};

const DEFAULT_HASH = "93c0295e48742e913c658cad22bfe825"; // hash with actual default img src

class ProfileEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateInfoActionId: null,
            saveEnabled: false,
            showAvatarSelector: true,
            error: null,
        };
    }

    componentWillUnmount() {
        //this.unsubscribes.forEach(u => u());
    }

    onAvatarSelect=(avatar_name,avatar_hash)=>{
        this.setState({ avatar_name, avatar_hash, saveEnabled: true });
    }
    
    onNameChange=(avatar_name)=>{
        this.setState({avatar_name, saveEnabled:true});
    }

    saveHandler=()=>{
        const actionId = uuid.v4();
        this.setState({ updateInfoActionId: actionId, showAvatarSelector: false });
        const avatar_name = this.state.avatar_name;
        const avatar_hash = this.state.avatar_hash;
        AccountActions.updateAvatar(actionId, {
            userId: this.props.user.id,
            avatar_name,
            avatar_hash: this.state.avatar_hash,
            callback: ()=>{
                this.setState({updateInfoActionId: null});
                if (this.props.onSave) {
                   this.props.onSave({avatar_name,avatar_hash});
                }
            }
        });
    }

    render() {
        const userInfo = this.props.user;
        // const defaultPortrait = GlobalConfig.StaticUrl + "/img/default-user-portrait.svg";
        let avatarName = this.state.avatar_name || userInfo.avatar_name || userInfo.display_name || userInfo.first_name;
        let avatarHash = this.state.avatar_hash || userInfo.avatar_hash || DEFAULT_HASH;

        return (
            <Row className={`${this.props.className}`}>
                <div className="col-12">
                    <h2>Profile
                        <span className="fa fa-close" onClick={this.props.onClose} aria-hidden />
                    </h2>
                    <hr/>
                    {/*<ErrorBox error={this.state.error} />*/}
                    <div className="settings-avatar">
                        <AvatarSelect 
                            avatarPromptText={'Choose Avatar Name and Portrait'}
                            playButtonText={'Select'}
                            setPlayerNameAndHash={this.onAvatarSelect} 
                            defaultPlayerName={avatarName} 
                            defaultAvatarHash={avatarHash} 
                            onNameChange={this.onNameChange}
                            />
                    </div>
                    <Form.Row>
                        <Button
                            disabled={this.props.disabled || !this.state.saveEnabled || !!this.state.updateInfoActionId}
                            onClick={this.saveHandler}
                            title={this.props.buttonTitle}
                        >
                            save changes
                        </Button>
                    </Form.Row>
                </div>
            </Row>
        );
    }
}

ProfileEdit.propTypes = propTypes;
ProfileEdit.defaultProps = defaultProps;

export default ProfileEdit;